export const pinSize = 100;